{
    "CustomNameLabel": "Nom :",
    "CustomWidthLabel": "Largeur (0 - 100) :",
    "CustomSettings_SectionHeader": "Paramètres personnalisés",
    "NAME": "CustomSettings"
}